















































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import Paging from '@/shared/components/Paging.vue';
import { DATA } from '@/config/data';
import { APP_CONFIG } from '@/config/app-config';
import { TransitionModel, SummaryTransitionModel } from '@/models/transition';

import ListTransition from './components/ListTransition.vue';
import FilterBox from './components/FilterBox.vue';

import authService from '@/services/auth-services';
import transitionServices from '@/services/transition-services';
import commonService from '@/services/common-services';

@Component({
    components: {
        ListTransition,
        FilterBox,
        Loading,
        Paging,
    }
})
export default class ListItem extends Vue {
    private mode: 'standard' | 'official' = 'standard';

    private filterProp = {
        selectedStatus: { value: -1, name: 'Tất cả', color: '#fff' },
        searchText: ''
    };
    private pageSettings = {
        rowPerPage: 15,
        pageSize: 6,
        pageIndex: 1,
        total: 0,
    };

    private summaryOrder: SummaryTransitionModel = new SummaryTransitionModel();
    private listItem: TransitionModel[] = [];
    private isLoading = false;
    private isShowModal = false;
    private customerInfo: any = {};

    // Danh cho Chinh ngach
    private officialItems: any[] = [];
    private officialSearch: string = '';
    private officialPage: number = 1;
    private officialRowsPerPage: number = 15;
    private officialTotal: number = 0;
    private officialTotalPages: number = 1;

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    private async created() {
        await this.loadData();
    }

    private switchMode(newMode: 'standard' | 'official') {
        this.mode = newMode;
        if (newMode === 'official' && this.officialItems.length === 0) {
            this.loadOfficialData();
        }
    }

    private async loadOfficialData() {
        this.isLoading = true;
        try {
            const res: any = await transitionServices.getOfficialList(
                this.officialPage,
                this.officialRowsPerPage,
                '',
                this.officialSearch.trim()
            );
            if (res && res.data && res.data.status === 200) {
                this.officialItems = res.data.data || [];
                this.officialTotal = res.data.total || 0;
                this.officialTotalPages = res.data.num_pages || Math.ceil(this.officialTotal / this.officialRowsPerPage) || 1;
            } else {
                this.officialItems = [];
                this.officialTotal = 0;
                this.officialTotalPages = 1;
            }
        } catch (e) {
            this.officialItems = [];
        } finally {
            this.isLoading = false;
        }
    }

    private changeOfficialPage(page: number) {
        if (page < 1 || page > this.officialTotalPages || page === this.officialPage) return;
        this.officialPage = page;
        this.loadOfficialData();
    }

    private async loadData() {
        this.isLoading = true;
        const filter = this.onBuildFilter();
        const result: any = await transitionServices.getList(
            this.pageSettings.pageIndex,
            this.pageSettings.rowPerPage,
            filter.filters,
            filter.quickFilters,
            false
        );
        this.isLoading = false;
        if (result && result.data.status === 200 && result.data.message === 'Success') {
            this.pageSettings.total = result.data.total;
            const tmpListTransition: TransitionModel[] = [];
            for (const item of result.data.data) {
                const transition = new TransitionModel();
                transition.ID = item.ID;
                transition.TransactionCode = item.TransactionCode;
                transition.Weight = item.Weight;
                transition.Length = item.Length;
                transition.Width = item.Width;
                transition.Height = item.Height;
                transition.Volume = item.Volume;
                transition.StoreCNImportDate = item.StoreCNImportDate;
                transition.StoreCNExportDate = item.StoreCNExportDate;
                transition.StoreVNImportDate = item.StoreVNImportDate;
                transition.StoreVNExportDate = item.StoreVNExportDate;
                transition.ProductName = item.ProductName;
                transition.ProductImage = item.ProductImage;
                transition.CreatedDate = item.CreatedDate;
                transition.PriceType = item.PriceType;
                transition.DepositCode = item.DepositCode;
                transition.Path = item.Path;
                transition.statusDetail = DATA.billOfLadingStatus.find(x => x.value === item.Status) || { value: 0, name: '', color: '#3b4354' };
                tmpListTransition.push(transition);
            }
            this.listItem = tmpListTransition;
        }
    }

    private onBuildFilter() {
        const paramsFilter: any = {
            filters: [],
            quickFilters: []
        };
        if (this.filterProp.selectedStatus.value !== -1) {
            paramsFilter.filters.push({
                column: 'Status',
                value: this.filterProp.selectedStatus.value,
                condition: 'equal'
            });
        }

        if (this.filterProp.searchText !== null &&
            this.filterProp.searchText !== undefined &&
            this.filterProp.searchText !== '') {
                paramsFilter.quickFilters.push({
                    column: 'TransactionCode',
                    value: this.filterProp.searchText,
                    condition: 'contain'
                });
                paramsFilter.quickFilters.push({
                    column: 'ID',
                    value: this.filterProp.searchText,
                    condition: 'contain'
                });
                paramsFilter.quickFilters.push({
                    column: 'OrderID',
                    value: this.filterProp.searchText,
                    condition: 'contain'
                });
        }

        return paramsFilter;
    }

    private onFilterChanged(data: any) {
        this.filterProp.selectedStatus = data.status;
        this.filterProp.searchText = data.searchText;
        this.pageSettings.pageIndex = 1;
        this.loadData();
    }

    private onChangePage(data: any) {
        this.pageSettings.pageIndex = data;
        this.loadData();
    }
}
